import moment from 'moment';

const d3 = Object.assign({},
    require('d3-transition'),
    require('d3-selection'),
    require('d3-selection-multi'),
    require('d3-array'),
    require('d3-shape'));

// see LinearBubbleRenderer for additional explanations
export class TimeLineRenderer {
    constructor ({
        chartDataHelper,
        chartRenderer,
        chartInteractions,
        scaler
    }) {
        this.chartDataHelper = chartDataHelper;
        this.chartRenderer = chartRenderer;
        this.interactions = chartInteractions;
        this.scaler = scaler;
        this.context = {
            margin: {
                left: 40, right: 10, top: 10, bottom: 60
            },
            palette: {
                fill: '#ff0000',
                stroke: '#444444'
            }
        };
        this.lineGenerator = d3.line()
            .x(d => this.scaler.x(moment(d[0]).startOf('day')) + this.context.margin.left)
            .y(d => this.scaler.y(d[1]) + this.context.margin.top);
        this.lineLandingGenerator = d3.line()
            .x(d => this.scaler.x(moment(d[0]).startOf('day')) + this.context.margin.left)
            .y(d => this.scaler.y(0) + this.context.margin.top);
    }

    render (mode) {
        let yAxisLabel = this.chartDataHelper.settings.yAxis.label;
        let xAxisLabel = this.chartDataHelper.settings.xAxis.label;

        this.chartRenderer.addAxisLines(this.scaler.axis);
        this.chartRenderer.addAxisLabels(this.context, xAxisLabel, yAxisLabel);

        this.chartRenderer.getMainZone()
            .selectAll('.series')
            .data(this.chartDataHelper.dataSeries, d => d.series)
            .join(enter => enter.append('g').attr('class', 'series'))
            .each((d, i, g) => {
                const seriesId = d.series;
                // render line dots
                d3.select(g[i])
                    .selectAll('circle')
                    .data(d.metric)
                    .join(
                        enter => enter
                            .append('circle')
                            .attr('r', 2)
                            .attr('cx', d => this.scaler.x(moment(d[0]).startOf('day')) + this.context.margin.left)
                            .attr('cy', d => this.scaler.y(0) + this.context.margin.top)
                            .on('mouseover', (d) => {
                                this.interactions.emitOverSeries({ seriesId, data: d, event });
                            })
                            .on('mouseout', (d) => {
                                this.interactions.emitOutSeries({ seriesId, data: d, event });
                            })
                            .on('click', (d) => {
                                this.interactions.emitClickSeries({ seriesId, data: d, event });
                            })
                    )
                    .transition()
                    .attr('fill', this.chartDataHelper.getSeriesColour(seriesId))
                    .attr('stroke', this.chartDataHelper.getSeriesColour(seriesId))
                    .attr('cx', d => this.scaler.x(moment(d[0]).startOf('day')) + this.context.margin.left)
                    .attr('cy', d => this.scaler.y(d[1]) + this.context.margin.top);
                // render line path
                d3.select(g[i])
                    .selectAll('path')
                    .data([d.metric])
                    .join(
                        enter => enter
                            .append('path')
                            .attrs({
                                'class': 'line',
                                'fill': 'none',
                                'stroke': this.chartDataHelper.getSeriesColour(seriesId),
                                'stroke-width': '2'
                            })
                            .attr('d', this.lineLandingGenerator)
                            .on('mouseover', (d) => {
                                window.event.target.setAttribute('stroke-width', '3');
                            })
                            .on('mouseout', (d) => {
                                window.event.target.setAttribute('stroke-width', '2');
                            })
                    )
                    .transition()
                    .attr('d', this.lineGenerator)
                    .attr('stroke', this.chartDataHelper.getSeriesColour(seriesId));
            });
    }
}
